import React, { FC, useEffect, useState } from 'react'
import './UpdateClientDetails.css'
import { CustomerAddress, CustomerAddressModel, CustomerContactDetailsModel, CustomerDetailsModel, CustomerModel, CustomerPersonalModel, IdentityType } from '../models/superbit-api-models'
import { Select } from 'antd';
import moment from 'moment-timezone';
import { CustomerCardModel } from '../models/CustomerCardModel';
import ClientContact from '../clients/_ClientContact';
import CompDatePicker from '../components/compDatePicker/_CompDatePicker';
import ClientAddress from '../clients/_ClientAddress';
import { cloneDeep } from 'lodash';
import { SimulatorModel } from '../models/SimulatorModel';


interface UpdateClientDetailsProps {
    clientData: CustomerPersonalModel;
    onClose: () => void;
    onSave: (identifeir: string) =>void;
}

type dataErrors = {
    identifier: boolean;
    identifierMessage: string;
    firstName?: boolean;
    lastName?: boolean;
    workplace?: boolean
}

const UpdateClientDetails: FC<UpdateClientDetailsProps> = (props: UpdateClientDetailsProps) => {

    const [dataForEdit, setDataForEdit] = React.useState<CustomerModel>(new CustomerModel(props.clientData.customerData))
    const [loadingSave, setLoadingSave] = React.useState<boolean>(false)

    const [clientDataErrors, setClientDataErrors] = React.useState<dataErrors>({
        identifier: false,
        identifierMessage: '',
        firstName: false,
        lastName: false,
        workplace: false
    });
    const [martialStatuses, setMartialStatuses] = useState<any[]>([]);
    const [personalData, setPersonalData] = useState<any>({});
    const [isPerson, setIsPerson] = useState<boolean>(true);
    const [identityIssueDate, setIdentityIssueDate] = useState<Date | null>(null)
    const [dateOfBirth, setDateOfBirth] = useState<Date | null>(null)
    const [driverLicensIssueDate, setDriverLicensIssueDate] = useState<Date | null>()
    const [citiesList, setCitiesList] = useState<any[]>([]);

    useEffect(() => {
        init()
    }, []);

    const init = async () => {
        const cities = new SimulatorModel().getCitiesAutocomplete();
        cities.sort((a: any, b: any) => (a.text > b.text) ? 1 : -1);
        setCitiesList(cities);

        setIdentityIssueDate(dataForEdit.identityIssueDate ? new Date(dataForEdit.identityIssueDate) : null);
        setDateOfBirth(dataForEdit.dateOfBirth ? new Date(dataForEdit.dateOfBirth) : null);
    }

    const isValidIsraeliId = (id: string): boolean => {
        // Check if the input is a string and has 9 digits
        if (!/^\d{9}$/.test(id)) return false;

        // Convert the ID number to an array of digits
        const digits = id.split('').map(Number);

        // Calculate the sum of the digits
        let sum = 0;
        for (let i = 0; i < 8; i++) {
            let digit = digits[i];
            if (i % 2 === 0) {
                // For even indices, multiply the digit by 1
                sum += digit;
            } else {
                // For odd indices, multiply the digit by 2 and add the digits of the result
                sum += Math.floor(digit * 2 / 10) + (digit * 2) % 10;
            }
        }

        // The ninth digit (check digit)
        const checkDigit = digits[8];

        // Validate the check digit
        return (sum + checkDigit) % 10 === 0;
    }

    const onDateChange = async (name: string, date: Date) => {
        console.log('onDateChange', date);
        switch (name) {
            case 'identityIssueDate':
                if (moment(date).isValid() && moment(date).format('YYYY-MM-DD') !== '0001-01-01') {
                    dataForEdit.identityIssueDate = new Date(date);
                    setIdentityIssueDate(date);
                } else {
                    dataForEdit.identityIssueDate = undefined;
                    setIdentityIssueDate(null);
                }
                break;
            case 'dateOfBirth':
                console.log('dateOfBirth-date', date, moment(date).isValid(), moment(date).format('YYYY-MM-DD') !== '0001-01-01');
                if (moment(date).isValid() && moment(date).format('YYYY-MM-DD') !== '0001-01-01') {
                    setDateOfBirth(date);
                    dataForEdit.dateOfBirth = date;
                } else {
                    dataForEdit.dateOfBirth = undefined;
                    setDateOfBirth(null)
                }
                break;
            case 'driverLicensIssueDate':
                dataForEdit.driverLicensIssueDate = date;
                setDriverLicensIssueDate(date);
                break;
            default:
                break;
        }
        setDataForEdit(dataForEdit);
    }


    const addNewContact = async () => {
        const newContact = new CustomerContactDetailsModel();
        const contacts: CustomerContactDetailsModel[] = dataForEdit.customerContactDetails ? dataForEdit.customerContactDetails : [];
        contacts.push(newContact);
        dataForEdit.customerContactDetails = contacts;
        await setDataForEdit(new CustomerModel(dataForEdit));
    }

    const onContactChange = (contact: CustomerContactDetailsModel, index: number) => {
        //console.log('onContactChange', contact);
        const data: CustomerModel = dataForEdit;
        if (data.customerContactDetails) {
            data.customerContactDetails[index] = contact;
            setDataForEdit(new CustomerModel(dataForEdit));
            // //console.log('onContactChange', contact, data.customerContactDetails);
        }
    }

    const onContactDelete = (address: CustomerContactDetailsModel, index: number) => {
        const data: CustomerModel = dataForEdit;
        if (data.customerContactDetails && data.customerContactDetails.length > 1) {
            data.customerContactDetails.splice(index, 1);
            setDataForEdit(new CustomerModel(dataForEdit));
            //console.log('onContactDelete', address, data.customerContactDetails);
        }
    }


    const checkIdentity = (id: string): boolean => {
        // clearIdentityError();
        const errors: dataErrors = clientDataErrors;
        const identityType: IdentityType = dataForEdit.identityType ? dataForEdit.identityType : IdentityType._1;
        if (!id) {
            errors.identifier = true;
            errors.identifierMessage = "שדה חובה";
            return false;
        }
        if (identityType == IdentityType._1 && !isValidIsraeliId(id)) {
            errors.identifier = true;
            if (id) {
                if (id.length != 9) {
                    errors.identifierMessage = "כמות ספרות לא חוקית";
                } else {
                    errors.identifierMessage = "מס' זהות לא תקין";
                }
            } else {
                errors.identifierMessage = "שדה חובה";
            }
            setClientDataErrors(errors)
            //console.log('checkIdentity', clientDataErrors)
            return false;
        } else {
            if (identityType == IdentityType._3) {
                if (id && id.length != 9 || !/^\d{9}$/.test(id)) {
                    errors.identifier = true;
                    errors.identifierMessage = "כמות ספרות לא חוקית";
                    setClientDataErrors(errors)
                    //console.log('checkIdentity', clientDataErrors)
                    return false;
                }
            }
        }
        return true;
    }

    const validateIsraelPhoneNumber = (phoneNumber: string): boolean => {
        // Regular expression for Israel phone numbers
        const israelPhoneNumberRegex = /^(0\d{1,2})-?(\d{3})-?(\d{4})$/;
        // Remove any non-digit characters from the phone number
        const cleanedPhoneNumber = phoneNumber.replace(/\D/g, '');
        // Check if the cleaned phone number matches the Israel phone number regex
        return israelPhoneNumberRegex.test(cleanedPhoneNumber);
    }


    const save = async () => {
        // savePersonalData
        let hasError: boolean = false;

        const identifier: string = dataForEdit.identifier;
        const identityType: IdentityType = dataForEdit.identityType ? dataForEdit.identityType : IdentityType._1;
        if (!checkIdentity(identifier)) {
            hasError = true;
            const d = dataForEdit
            d.identifier = dataForEdit.identifier;
            setDataForEdit(new CustomerModel(d));
            console.log('clientDataErrors', clientDataErrors);
        }
        // else {
        //     if (mode != ViewMode.EDIT) {
        //         const customerDetails: any = await simulatorModel.getCustomerDetailsById(identifier);
        //         if (customerDetails && customerDetails.customer) {
        //             hasError = true;
        //             clientDataErrors.identifier = true;
        //             clientDataErrors.identifierMessage = "לקוח קיים במערכת, שונו פרטי לקוח";
        //             setClientDataErrors(clientDataErrors)
        //         }
        //     }
        // }
        if (dataForEdit.customerContactDetails && dataForEdit.customerContactDetails.length > 0) {
            dataForEdit.customerContactDetails.forEach((contact: CustomerContactDetailsModel, index: number) => {
                // contact.hasError = false;
                if (contact.hasError) {
                    hasError = true;
                }
                if (!contact.title || contact.title == '') {
                    hasError = true;
                    contact.hasError = true
                }
                let phoneNumber = contact.number ? contact.number.trim() : '';
                console.log('contact.number', phoneNumber.length, phoneNumber, validateIsraelPhoneNumber(phoneNumber))
                if (index == 0 && (!phoneNumber || phoneNumber == '')) {
                    console.log("contact.number 'phoneNumber == '' or undifind", "")
                    hasError = true;
                    contact.hasError = true
                }
                if ((phoneNumber && phoneNumber.trim().length < 9) || (phoneNumber && validateIsraelPhoneNumber(phoneNumber) == false)) {
                    console.log("contact.number 'phoneNumber < 9 '' or validateIsraelPhoneNumber == false", "")
                    hasError = true;
                    contact.hasError = true
                } else {
                    console.log('contact.number valid', phoneNumber)
                }

            })
        }

        if (dataForEdit.customerAddresses && dataForEdit.customerAddresses.length > 0) {
            dataForEdit.customerAddresses.forEach((address: CustomerAddress) => {
                // contact.hasError = false;
                // 
                console.log('save address', address)
                // if (address.hasError) {
                //     hasError = true;
                // }
                if (!address.city || address.city == '') {
                    hasError = true;
                    address.hasError = true
                } else
                    if ((!address.street || address.street == '') && (!address.mailbox || address.mailbox == '')) {
                        hasError = true;
                        address.hasError = true
                    } else if ((!address.mailbox || address.mailbox === '') && ((!address.houseNumber || address.houseNumber == 0) || (typeof address.houseNumber === "string" && address.houseNumber === ""))) {
                        console.log('typeof address.houseNumber', typeof address.houseNumber)
                        hasError = true;
                        address.hasError = true
                    } else {
                        address.hasError = false;
                    }

                if (!address.addressType) {
                    address.addressType = "0";
                } else {
                    address.addressType = address.addressType
                }

            })
        }

        let errors: dataErrors = clientDataErrors;
        if (dataForEdit.identityType !== IdentityType._3) {
            if (!dataForEdit.firstName || dataForEdit.firstName == '') {
                hasError = true;
                errors.firstName = true;
            } else {
                errors.firstName = false;
            }
            if (!dataForEdit.lastName || dataForEdit.lastName == '') {
                hasError = true;
                errors.lastName = true;
            } else {
                errors.lastName = false;
            }
        } else {
            dataForEdit.dateOfBirth = undefined;
            if (!dataForEdit.firstName || dataForEdit.firstName == '') {
                hasError = true;
                errors.firstName = true;
            } else {
                dataForEdit.firstName = dataForEdit.firstName;
                errors.firstName = false;
            }
        }
        console.log('clientDataErrors', errors)
        console.log('hasError', hasError)
        setClientDataErrors(errors);

        if (hasError) {
            const d = dataForEdit
            d.identifier = dataForEdit.identifier;
            d.firstName = dataForEdit.firstName;
            d.lastName = dataForEdit.lastName;
            setDataForEdit(new CustomerModel(d));
            return;
        }

        const d = dataForEdit;
        if (!d.identityIssueDate || moment(d.identityIssueDate).format('YYYY-MM-DD') == '0001-01-01') {
            d.identityIssueDate = undefined;
        }
        // d.createdDate = new Date(dataForEdit.createdDate);


        if (d.vehicles) {
            d.vehicles.forEach((v: any) => {
                if (moment(v.entryToRoadDate).isValid() && moment(v.entryToRoadDate).isAfter('1900-01-2401T00:00:00Z')) {
                } else {
                    v.entryToRoadDate = undefined
                }
            })
            setDataForEdit(new CustomerModel(d));
            // props.updateEditData(props.customerId, d);
        }
        console.log('save', dataForEdit);
        setLoadingSave(true);
        new CustomerCardModel().savePersonalData(d).then((res: any) => {
            setLoadingSave(false);

            console.log(res);
            setPersonalData(new CustomerModel(d));
            props.onSave(d.identifier ? d.identifier : '');
            // if (props.setMessege && props.setPopupShow) {
            //     props.setMessege("פרטי לקוח עודכנו בהצלחה");
            //     props.setPopupShow(true);
            // }
        })

    }

    const removeNonHebrewCharacters = (input: string): string => {
        return input.replace(/[^\u0590-\u05FF\s'"-]/g, '');
        // const regex =     /[^\u0590-\u05FF\s.,]/g;
    }

    const onInputBlur = async (name: string, value: string) => {
        const data: any = dataForEdit as any;
        const errors: dataErrors = clientDataErrors;
        if (value && value != '') {
            switch (name) {
                case 'identifier':
                    value = value.trim();

                    // data[name] = value;
                    break;

                // case 'firstName': {
                //     if (value == '') {
                //         errors.firstName = true;
                //     } else {
                //         errors.firstName = false;
                //     }
                //     data[name] = value;
                //     break
                // }
                // case 'lastName': {
                //     if (value == '') {
                //         errors.lastName = true;
                //     } else {
                //         errors.lastName = false;
                //     }
                //     data[name] = value;
                //     break
                // }
                default:
                    // data[name] = value;
                    break;
            }
        }
        await setDataForEdit(new CustomerModel(data));
        //console.log('onParamChange', name, value);
    }
    const onInputFocus = async (name: string, value: string) => {
        const data: any = dataForEdit as any;
        const errors: dataErrors = clientDataErrors;
        switch (name) {
            case 'identifier':
                errors.identifier = false
                setClientDataErrors(errors);
                break;
            default:
                // data[name] = value;
                break;
        }
        await setDataForEdit(new CustomerModel(data));
        //console.log('onParamChange', name, value);
    }

    const setGender = (value: string, option: { label: string; value: string; } | { label: string; value: string; }[] | undefined) => {
        console.log('setGender', value, option);
        (dataForEdit.gender as any) = value;
        setDataForEdit(new CustomerModel(dataForEdit));
    }

    const getUpdatedCustomerAge = () => {
        let age: number = 0;
        if (dataForEdit && dataForEdit.dateOfBirth && moment(dataForEdit.dateOfBirth).format('YYYY-MM-DD') !== '0001-01-01') {
            const today: moment.Moment = moment();
            const birthdate: moment.Moment = moment(dataForEdit.dateOfBirth);
            age = today.diff(birthdate, 'years');
        }
        return age > 0 ? age : '';
    }

    const setMartialStatus = (value: string, option: { label: string; value: string; } | { label: string; value: string; }[] | undefined) => {
        console.log('setMartialStatus', value, option);
        (dataForEdit.maritalStatus as any) = value;
        setDataForEdit(new CustomerModel(dataForEdit));
    }

    const onParamChange = async (name: string, value: string) => {
        const data: any = dataForEdit as any;
        const errors: dataErrors = clientDataErrors;
        // data[name] = '';
        // await setDataForEdit(new CustomerModel(data));
        switch (name) {
            case 'identifier':
                value = value.replace(/[^0-9]/g, '');
                data[name] = value;
                break;

            case 'firstName': {
                value = removeNonHebrewCharacters(value);
                if (value == '') {
                    errors.firstName = true;
                } else {
                    value = removeNonHebrewCharacters(value);
                    errors.firstName = false;
                }
                data[name] = value;
                break
            }
            case 'lastName': {
                value = removeNonHebrewCharacters(value);
                if (value == '') {
                    errors.lastName = true;
                } else {
                    errors.lastName = false;
                }
                data[name] = value;
                break
            }
            case 'companyName': {
                if (value == '') {
                    errors.firstName = true;
                } else {
                    errors.firstName = false;
                }
                data['firstName'] = value;
                break
            }
            case 'workplace': {
                value = removeNonHebrewCharacters(value);
                if (value == '') {
                    errors.workplace = true;
                } else {
                    value = removeNonHebrewCharacters(value);
                    errors.workplace = false;
                }
                data[name] = value;
                break
            }
            case 'driverLicenseNumber':
                value = value.replace(/\D/g, '');
                data[name] = value;
                break;

            default:
                data[name] = value;
                break;
        }
        // console.log('setDataForEdit', name, value, data)
        await setDataForEdit(new CustomerModel(data));
        // console.log('onParamChange', name, value);
    }

    const toggleDetailsType = (newType: IdentityType) => {
        const currType = newType == IdentityType._1;
        const data: CustomerModel = dataForEdit;
        if (currType) {
            data.identityType = IdentityType._1
            // identityType == IdentityType._1
        } else {
            data.identityType = IdentityType._3
        }
        console.log('toggleDetailsType', data.identityType);
        setDataForEdit(new CustomerModel(data));
        setIsPerson(currType);
    }

    const addNewAddress = async () => {
        const newAddress = new CustomerAddressModel();
        const addresses: CustomerAddressModel[] = dataForEdit.customerAddresses ? dataForEdit.customerAddresses : [];
        addresses.push(newAddress);
        dataForEdit.customerAddresses = [...addresses];
        await setDataForEdit(new CustomerModel(dataForEdit));
    }

    const onAddressChange = async (address: CustomerAddressModel, index: number) => {
        const data: CustomerModel = dataForEdit;
        if (data.customerAddresses) {
            data.customerAddresses[index] = address;
            setDataForEdit(new CustomerModel(dataForEdit));
            //console.log('onAddressChange', address, dataForEdit.customerAddresses);
        }
    }

    const onAddressDelete = async (index: number) => {
        // const data = cloneDeep(dataForEdit);
        // if (data.customerAddresses) {
        //     console.log('data.customerAddresses index', index)
        //     console.log('data.customerAddresses after splice before', data.customerAddresses);
        //     let addressAfterDelete = data.customerAddresses.filter((addr: any, indexAdre: number) => (indexAdre !== index));
        //     // data.customerAddresses.splice(index, 1);
        //     console.log('data.customerAddresses after splice', addressAfterDelete);
        //     data.customerAddresses = [];
        //     data.customerAddresses = [...addressAfterDelete];
        //     setDataForEdit(new CustomerModel(data));
        //     //console.log('onAddressDelete', address, data.customerAddresses);
        //     // if (address.id) {
        //     //     const data: Input = new Input({
        //     //         id: address.id.toString()
        //     //     });
        //     //     await customerCardModel.deleteCustomerAddressDetails(data)
        //     // }
        // }
        setDataForEdit(prev => {
            if (!prev.customerAddresses) return prev;

            const next = cloneDeep(prev); // or new CustomerModel(prev)
            next.customerAddresses = prev.customerAddresses.filter((_, i) => i !== index);
            return new CustomerModel(next);
        });
    }


    const emptyFunc = () => { }


    return (
        // popup form to update client details
        <div className='update-client-details'>
            <div className='update-client-details-header'>
                עדכון פרטי לקוח
            </div>
            <div className='update-client-details-body'>
                <div className="client-tab-content-block client-details personal-details">
                    <div className="tab-content-title">
                        פרטים אישיים
                    </div>
                    <div className="parameter-row">
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    &nbsp;
                                </div>
                                <div className="value toggle">
                                    <input type="radio" className="toggle-input client-type client-type-personal" id="private01" name="client_type01" value="private" data-type="personal" checked={dataForEdit.identityType == IdentityType._0 || dataForEdit.identityType == IdentityType._1} />
                                    <label onClick={() => toggleDetailsType(IdentityType._1)}>
                                        לקוח פרטי
                                    </label>
                                    <input type="radio" className="toggle-input client-type client-type-company" id="company01" name="client_type01" value="company" data-type="company" checked={dataForEdit.identityType == IdentityType._3} />
                                    <label onClick={() => toggleDetailsType(IdentityType._3)}>
                                        חברה
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className={`parameter-item ${clientDataErrors && clientDataErrors.identifier ? 'error' : 'no-error'}`}>
                            <div className="field">
                                <div className="title">
                                    {dataForEdit.identityType == IdentityType._0 || dataForEdit.identityType == IdentityType._1 ? (<>
                                        ת.ז.
                                    </>) : (<>
                                    </>)}
                                    {dataForEdit.identityType == IdentityType._3 ? (<>
                                        ח.פ.
                                    </>) : (<>
                                    </>)}
                                </div>
                                <div className="value">
                                    <input type="text" value={dataForEdit.identifier} onChange={(e: any) => onParamChange('identifier', e.target.value)} onBlur={() => onInputBlur('identifier', dataForEdit.identifier)} onFocus={() => onInputFocus('identifier', dataForEdit.identifier)} />
                                </div>
                                <div className='error-message'>
                                    *{clientDataErrors.identifierMessage}
                                </div>
                            </div>
                        </div>
                        {dataForEdit.identityType == IdentityType._0 || dataForEdit.identityType == IdentityType._1 ? (<>
                            <div className={`parameter-item ${clientDataErrors && clientDataErrors.firstName ? 'error' : 'no-error'}`}>
                                <div className="field">
                                    <div className="title">
                                        שם פרטי
                                    </div>
                                    <div className="value">
                                        <input type="text" value={dataForEdit.firstName} onChange={(e: any) => onParamChange('firstName', e.target.value)} />
                                    </div>
                                    <div className='error-message'>
                                        *שדה חובה
                                    </div>
                                </div>
                            </div>
                        </>) : (<>
                        </>)}

                        {dataForEdit.identityType == IdentityType._3 ? (<>
                            <div className={`parameter-item ${clientDataErrors && clientDataErrors.firstName ? 'error' : 'no-error'}`}>
                                <div className="field">
                                    <div className="title">
                                        שם עסק
                                    </div>
                                    <div className="value">
                                        <input type="text" value={dataForEdit.firstName} onChange={(e: any) => onParamChange('companyName', e.target.value)} />
                                    </div>
                                    <div className='error-message'>
                                        *שדה חובה
                                    </div>
                                </div>
                            </div>
                        </>) : (<>
                        </>)}

                        <div className={`parameter-item ${clientDataErrors && clientDataErrors.lastName ? 'error' : 'no-error'} ${dataForEdit.identityType == IdentityType._0 || dataForEdit.identityType == IdentityType._1 ? '' : 'hide'}`}>
                            <div className="field">
                                <div className="title">
                                    שם משפחה
                                </div>
                                <div className="value">
                                    <input type="text" value={dataForEdit.lastName} onChange={(e: any) => onParamChange('lastName', e.target.value)} />
                                </div>
                                <div className='error-message'>
                                    *שדה חובה
                                </div>
                            </div>
                        </div>
                        <div className={`parameter-item ${dataForEdit.identityType == IdentityType._3 ? '' : 'hide'}`}>
                            <div className="field">
                                <div className="title">
                                    תחום העסק
                                </div>
                                <div className="value">
                                    <input type="text" value={dataForEdit.businessTitle} onChange={(e: any) => onParamChange('businessTitle', e.target.value)} />
                                </div>
                                {/* <div className='error-message'>
                                            *שדה חובה
                                        </div> */}
                            </div>
                        </div>
                    </div>
                    <div className={`parameter-row ${dataForEdit.identityType == IdentityType._0 || dataForEdit.identityType == IdentityType._1 ? '' : 'hide'}`}>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    מגדר
                                </div>
                                <div className="value">
                                    <Select
                                        style={{ width: '100%' }}
                                        placeholder="מגדר"
                                        value={dataForEdit && dataForEdit.gender ? dataForEdit.gender.toString() : "0"}
                                        onChange={setGender}
                                        options={[{
                                            "label": "זכר",
                                            "value": "0"
                                        },
                                        {
                                            "label": "נקבה",
                                            "value": "1"
                                        }
                                        ]}
                                    />

                                </div>
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    תאריך הנפקת ת.ז.
                                </div>
                                <div className="value">
                                    <CompDatePicker value={identityIssueDate} onChange={(date: Date) => onDateChange('identityIssueDate', date)} />

                                </div>

                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    תאריך לידה
                                </div>
                                <div className="value">
                                    <CompDatePicker value={dateOfBirth} onChange={(date: Date) => onDateChange('dateOfBirth', date)} />

                                </div>
                            </div>
                            <div className="field">
                                <div className="title">
                                    גיל
                                </div>
                                <div className="value grey-text-age">
                                    {getUpdatedCustomerAge()}
                                </div>
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    מצב משפחתי
                                </div>
                                <div className="value" title={`maritalStatus is ${dataForEdit.maritalStatus ? dataForEdit.maritalStatus.toString() : 'NONE'}`}>
                                    <Select
                                        style={{ width: '100%' }}
                                        placeholder="מצב משפחתי"
                                        // defaultValue={dataForEdit && dataForEdit.maritalStatus ? dataForEdit.maritalStatus.toString() : props.config.martialStatuses[0]}
                                        value={dataForEdit && dataForEdit.maritalStatus ? dataForEdit.maritalStatus.toString() : "0"}
                                        onChange={setMartialStatus}
                                        options={[
                                            {
                                                "label": "רווק/ה",
                                                "value": "0"
                                            },
                                            {
                                                "label": "נשוי/אה",
                                                "value": "1"
                                            },
                                            {
                                                "label": "גרוש/ה",
                                                "value": "2"
                                            },
                                            {
                                                "label": "אלמן/ה",
                                                "value": "3"
                                            }
                                        ]
                                        }
                                    />

                                </div>
                            </div>
                        </div>

                    </div>
                    <div className={`parameter-row ${dataForEdit.identityType == IdentityType._3 ? '' : 'hide'}`}>
                        <div className={`parameter-item`}>
                            <div className="field">
                                <div className="title">
                                    מספר עובדים
                                </div>
                                <div className="value">
                                    <input type="text" value={dataForEdit.workerNumber} onChange={(e: any) => onParamChange('workerNumber', e.target.value)} />
                                </div>

                            </div>
                        </div>
                        <div className={`parameter-item`}></div>
                        <div className={`parameter-item`}></div>
                        <div className={`parameter-item`}></div>
                    </div>
                </div>
                <div className="client-tab-content-block client-details company-details hide">
                    <div className="tab-content-title">
                        פרטים אישיים
                    </div>
                    <div className="parameter-row">
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    &nbsp;
                                </div>
                                <div className="value toggle">
                                    <input type="radio" className="toggle-input client-type client-type-personal" id="private02" name="client_type02" data-type="personal" value="private" onClick={emptyFunc} />
                                    <label>
                                        לקוח פרטי
                                    </label>
                                    <input type="radio" className="toggle-input client-type client-type-company" id="company02" name="client_type02" data-type="company" value="company" checked onClick={emptyFunc} />
                                    <label>
                                        חברה
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    ח.פ
                                </div>
                                <div className="value">
                                    <input type="text" value={''} />
                                </div>
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    שם העסק
                                </div>
                                <div className="value">
                                    <input type="text" value={''} />
                                </div>
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    שם העסק
                                </div>
                                <div className="value">
                                    <input type="text" value={''} />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="client-tab-content-block">
                    <div className="tab-content-title">
                        <span>
                            אנשי קשר
                        </span>

                        <button className="button blue has-icon only-icon">
                            <div className="icon add" onClick={addNewContact}></div>
                        </button>
                    </div>
                    <div>
                    </div>
                    <div className="parameter-row">
                        <div className="parameter-item checkbox">
                            <div className="title">
                                עיקרי
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="title">
                                שם
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="title">
                                אימייל
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="title">
                                טלפון/פקס
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="title">
                                הערות
                            </div>
                        </div>
                        <div className="parameter-item action"></div>
                    </div>
                    {
                        dataForEdit.customerContactDetails && dataForEdit.customerContactDetails.length > 0 ? (<>
                            {
                                dataForEdit.customerContactDetails.map((contact: CustomerContactDetailsModel, i: number) => {
                                    return (
                                        <ClientContact contact={contact} key={i} index={i} config={{
                                            canBeDeleted: dataForEdit.customerContactDetails && dataForEdit.customerContactDetails.length > 1,
                                            onChange: (contact: CustomerAddressModel) => onContactChange(contact, i),
                                            onDelete: (contact: any) => onContactDelete(contact, i)
                                        }} />
                                    )

                                })}
                        </>) : (<>
                        </>)
                    }
                </div>
                <div className="client-tab-content-block">
                    <div className="tab-content-title">
                        <span>
                            כתובות
                        </span>

                        <button className="button blue has-icon only-icon pointer">
                            <div className="icon add" onClick={addNewAddress}></div>
                        </button>
                    </div>
                    <div className="parameter-row">
                        <div className="parameter-item">
                            <div className="title">
                                ישוב
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="title">
                                רחוב
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="title">
                                מספר
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="title">
                                דירה
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="title">
                                כניסה
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="title">
                                ת.ד
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="title">
                                מיקוד
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="title">
                                כתובת משלוח
                            </div>
                        </div>
                        <div className="parameter-item action">
                        </div>
                    </div>
                    {dataForEdit.customerAddresses ? (<>
                        {dataForEdit.customerAddresses.map((address: CustomerAddressModel, i: number) => {
                            return (
                                // <ClientAddress config={{
                                //     cities: props.config.cities,
                                //     onChange: (address: CustomerAddressModel) => onAddressChange(address, i),
                                //     onDelete: (address: CustomerAddressModel, key: number) => onAddressDelete(address, key)
                                // }} customerAddress={address} index={i} />
                                <ClientAddress
                                    key={address.id ?? i} // better: always a real id, fallback i if you must
                                    config={{
                                        cities: citiesList,
                                        onChange: (addr: CustomerAddressModel) => onAddressChange(addr, i),
                                        onDelete: () => onAddressDelete(i),
                                    }}
                                    customerAddress={address}
                                    index={i}
                                />
                            )
                        })}
                    </>) : (<></>)}
                </div>

                <div className="client-tab-content-block">
                    <div className="tab-content-title">
                        רשיון
                    </div>
                    <div className="parameter-row">
                        <div className="parameter-item">
                            <div className="title">
                                מספר רשיון
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="title">
                                סוג רשיון
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="title">
                                תאריך קבלת רשיון
                            </div>
                        </div>
                        <div className="parameter-item">
                        </div>
                    </div>

                    <div className="parameter-row">
                        <div className="parameter-item">
                            <div className="field">
                                <div className="value">
                                    <input type="text" value={dataForEdit.driverLicenseNumber} onChange={(e: any) => onParamChange('driverLicenseNumber', e.target.value)} />
                                </div>
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="value">
                                    <input type="text" value={''} />
                                    <div className="icon small-icon select-arrow pointer"></div>
                                </div>
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="value">
                                    <CompDatePicker value={driverLicensIssueDate} onChange={(date: Date) => onDateChange('driverLicensIssueDate', date)} />

                                </div>
                            </div>
                        </div>
                        <div className="parameter-item"></div>
                    </div>
                </div>
                <div className="client-tab-content-block">
                    <div className="tab-content-title">
                        עבודה
                    </div>
                    <div className="parameter-row">
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    מקום עבודה
                                </div>
                                <div className="value">
                                    <input type="text" value={''} />
                                </div>
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    תפקיד
                                </div>
                                <div className="value">
                                    <input type="text" value={''} />
                                    <div className="icon small-icon select-arrow pointer"></div>
                                </div>
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    מספר עובד
                                </div>
                                <div className="value">
                                    <input type="text" value={''} />
                                    <div className="icon small-icon select-arrow pointer"></div>
                                </div>
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    משכורת
                                </div>
                                <div className="value">
                                    <input type="text" value={''} />
                                </div>
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    מקצוע
                                </div>
                                <div className="value">
                                    <input type="text" value={''} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="client-tab-content-block">
                    <div className="tab-content-title">
                        פרטים נוספים
                    </div>

                </div>
            </div>
            <div className="btn-row">
                <button className='btn-save-client' onClick={save}>
                    שמירה
                    <img src={require("../assets/images/loading.gif")} className={loadingSave ? "loadingGif" : "hide"} />
                </button>

                <button className='btn-cancel' onClick={() => { props.onClose() }}>
                    ביטול
                </button>
            </div>


        </div>
    )
}

export default UpdateClientDetails